import React from 'react';
import { LayoutWithNavbar } from 'layouts';
import ReactLoading from 'react-loading';
import './PageLoader.scss';

const PageLoader = () => (
  <div className="page-loader">
    <ReactLoading height="32px" width="32px" color="#e48196" type="spin" />
  </div>
);

export default LayoutWithNavbar(PageLoader);
